import React from "react";
import PropTypes from 'prop-types';
import {Flex} from "../Layout";
import {TimelineContainer} from "./styles/Timeline";

export default class Timeline extends React.Component {
    render(){
        return(
            <TimelineContainer borderProps={this.props.borderProperties}>
                <Flex>
                    {this.props.children}
                </Flex>
            </TimelineContainer>
        )
    }
}

Timeline.PropTypes = {
    children: PropTypes.node.isRequired,
    borderProperties: PropTypes.object
};